import { render, staticRenderFns } from "./orderInfoSection.vue?vue&type=template&id=14fc621c&scoped=true"
import script from "./orderInfoSection.vue?vue&type=script&lang=js"
export * from "./orderInfoSection.vue?vue&type=script&lang=js"
import style0 from "./orderInfoSection.vue?vue&type=style&index=0&id=14fc621c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc621c",
  null
  
)

export default component.exports